import React from 'react';
import PropTypes from 'prop-types';

import Form from 'react-bootstrap/Form';

const Checkbox = (props) => {
  const {
    inline,
    type,
    name,
    label,
    checked,
    disabled,
    value,
    onChange,
    id,
  } = props;

  return (
    <Form.Check
      inline={inline}
      type={type}
      label={label}
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={(onChange)}
      id={id}
    />
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  inline: PropTypes.bool,
  type: PropTypes.oneOf(['checkbox', 'switch', 'radio']),
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.string,
};

Checkbox.defaultProps = {
  label: '',
  inline: false,
  type: 'checkbox',
  name: null,
  value: null,
  disabled: false,
  onChange: null,
  checked: false,
  id: '',
};

export default Checkbox;
